module.exports = __webpack_public_path__ + "static/img/product11.8cd4399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product11.png
// module id = b7a4
// module chunks = 13